import React from 'react';
import DescriptorDropdown from '../DescriptorDropdown';
import { processDescriptorsWithFrequencies } from 'utils/filterDataProcessors';

/**
 * Component for displaying and managing demographic filters
 */
const DemographicFilters = ({
  descriptorsData,
  filters,
  filterReport,
  onToggleDemographic,
  onClearDemographic,
  onApplyFilter,
  dropdownAbove,
  defaultOpen = false,
  onDeleteFilter
}) => {
  // Handle case where filters or filters.multi_choices might be undefined
  const safeFilters = {
    ...filters,
    multi_choices: filters?.multi_choices || {}
  };

  const descriptorsWithFrequencies = processDescriptorsWithFrequencies(
    descriptorsData, 
    safeFilters, 
    filterReport
  );

  if (!descriptorsWithFrequencies || descriptorsWithFrequencies.length === 0) {
    return null;
  }

  return (
    <>
      {descriptorsWithFrequencies.map((descriptor, index) => (
        <DescriptorDropdown
          key={descriptor.id || index}
          name={descriptor.name}
          codes={(descriptor.multi_choices || []).map((choice) => ({
            name: choice.choice,
            id: choice.id,
            count: choice.count || 0,
            checked: safeFilters.multi_choices[descriptor.id]?.includes(choice.id) || false
          }))}
          onChecked={(choiceID, checked) => onToggleDemographic(descriptor.id, choiceID)}
          onClearChecked={() => onClearDemographic(descriptor.id)}
          applyFilter={onApplyFilter}
          dropdownAbove={dropdownAbove}
          defaultOpen={defaultOpen && index === 0}
          onDeleteFilter={onDeleteFilter}
        />
      ))}
    </>
  );
};

export default DemographicFilters;
